import React from "react";
import { Message } from "components/generic/layout";
import { Overlay } from "components/common/candidate";

export default () => (
  <Overlay>
    <Message
      title="Successfully rescheduled!"
      text="You'll receive a confirmation soon. Check your email!"
      showIcon
    />
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/RescheduleSuccess/index.js